export const useLocalStorageSession = (
  key: string,
  value?: string,
): { setItem: () => void; getItem: () => string | null } => {
  return {
    setItem: () => value && window.localStorage.setItem(key, value),
    getItem: () => {
      return window.localStorage.getItem(key);
    },
  };
};
